import { Cloudinary } from '@cloudinary/url-gen';

const arIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M18.25 7.6l-5.5-3.18c-.46-.27-1.04-.27-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3zM7 14.96v-4.62l4 2.32v4.61l-4-2.31zm5-4.03L8 8.61l4-2.31 4 2.31-4 2.32zm1 6.34v-4.61l4-2.32v4.62l-4 2.31zM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3V2zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3V2zM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3v2zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3v2z"/></svg>';

const closeIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"></path></svg>';

const graphicSrc =
  'https://res.cloudinary.com/prod/image/upload/v1635857842/widgets/3dar/view_in_ar.svg';

const cldLogo =
  'https://cloudinary-marketing-res.cloudinary.com/image/upload/c_pad,b_auto:predominant,fl_preserve_transparency/v1652806224/cloudinary_logo_white_0720_svg.svg';

const QR_BUTTON_TEMPLATE = `
  <style>
    button.ar-button {
      position: absolute;
      right: 2rem;
      bottom: 2rem;
      color: #fff;
      border: 0px;
      font-size: 14px;
      background: #005CE4;
      cursor: pointer;
      padding: 0.75rem 1.25rem;
      border-radius: 10rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-family: Arial, sans-serif;
      box-shadow: -3px 8px 24px -10px rgba(0,0,0,0.75);
      -webkit-box-shadow: -3px 8px 24px -10px rgba(0,0,0,0.75);
      -moz-box-shadow: -3px 8px 24px -10px rgba(0,0,0,0.75);
    }

    .ar-button svg {
      margin-right: 0.25rem;
    }

    .ar-button path {
      fill: #fff;
    }
  </style>
  <button class="ar-button" alt="Get QR code to view in AR">
    ${arIcon}
    <span>View in AR</span>
  </button>
`;

const QR_MODAL_TEMPLATE = `
  <style>
    .qr-code-modal {
      container-type: inline-size;
      position: absolute;
      z-index: 100;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
      backdrop-filter: blur(10px);
      cursor: default;
      width: 100%;
      height: 100%;
      font-family: Arial, sans-serif;
      font-size: 13px;
      display: none;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .qr-code-modal.show {
      display: flex;
    }

    .qr-code-modal .qr-code-modal-content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      height: 100%;
    }

    .qr-code-modal .qr-data-container {
      display: flex;
      justify-content: space-around;
      height: 70%;
      gap: 2em;
      margin: 0 2em;
    }

    .qr-code-modal .qr-data-section {
      color: white;
      font-size: 2.3em;
      display: flex;
      flex-direction: column;
      flex: 1;
      padding-top: 1rem;
    }

    .qr-code-modal .qr-data-section h4 {
      font-size: 1em;
    }

    .qr-code-modal .qr-data-section a {
      color: rgb(142, 232, 255);
    }

    .qr-code-modal .qr-info {
      display: flex;
      color: white;
      font-size: 2.3em;
      height: 30%;
      width: 80%;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }

    .qr-code-modal .qr-info img {
      height: 3em;
    }

    .qr-code-modal .qr-info p {
      margin: 0.15em 1.15em;
    }

    .qr-code-modal .qr svg {
      height: 9em;
    }

    .qr-code-modal img.qr-cld-logo  {
      width: 150px;
      height: auto;
      max-width: 35%;
      margin: 0.5em auto 0.8em;
    }

    .qr-code-modal .qr-close {
      background: transparent;
      border: 0;
      width: 48px;
      height: 48px;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
    }

    .qr-code-modal .qr-close path {
      fill: #fff;
    }

    @container (max-width: 680px) {
      .qr-code-modal .qr-code-modal-content {
        font-size: 75%;
      }
    }

    @container (max-width: 560px) {
      .qr-code-modal .qr-code-modal-content {
        font-size: 60%;
      }
    }

    @container (max-width: 420px) {
      .qr-code-modal .qr-code-modal-content {
        font-size: 50%;
      }
      .qr-code-modal .qr-data-section h4,
      .qr-code-modal .qr-data-section.copy-ar {
        display: none;
      }
      .qr-code-modal .qr svg {
        max-width: 50%;
      }
    }
  </style>

  <div class="qr-code-modal">
    <button alt="Close QR modal" class="qr-close">
      ${closeIcon}
    </button>
    <div class="qr-code-modal-content">
      <div class="qr-info">
        <img src="${graphicSrc}" alt="" role="presentation" />
        <p>
          <strong>View in your own space</strong> in augmented reality
        </p>
      </div>
      <div class="qr-data-container">
        <div class="qr-data-section scan-qr">
          <h4>Scan this qr code:</h4>
          <div class="qr">
          </div>
        </div>
        <div class="qr-data-section copy-ar">
          <h4>Or click to copy this url:</h4>
          <div class="qr-url">
          </div>
        </div>
      </div>
    </div>
    <img src="${cldLogo}" class="qr-cld-logo" alt="Powered by Cloudinary" />
  </div>
`;

export const getQrCodeButtonElement = () => {
  const template = document.createElement('template');
  template.innerHTML = QR_BUTTON_TEMPLATE;

  return template.content.cloneNode(true);
};

export const getQrCodeModalElement = () => {
  const template = document.createElement('template');
  template.innerHTML = QR_MODAL_TEMPLATE;

  return template.content.cloneNode(true);
};

export const generateQrUrl = ({
  cloudName,
  publicId
  // placement,
  // variantId,
  // locale
}) => {
  const cldEnv = window.location.hostname.match(
    /(.*)-(staging(\d)?|nightly)\.cloudinary\.com/
  )?.[2];
  const env = cldEnv || localStorage.getItem('env');
  const urlBase = `https://ar-splash${env ? `-${env}` : ''}.cloudinary.com/`;
  const params = new URLSearchParams();
  params.append('cloudName', cloudName);
  params.append('publicId', publicId);
  // params.append('placement', placement);
  // variantId && params.append('variantId', variantId);
  // params.append('locale', locale);

  return `${urlBase}?${params.toString()}`;
};

const E_SWAP_IMAGE = 'e_swap_image';

const FORMAT = {
  ios: 'usdz',
  android: 'glb'
};

const swapImageTransformation = (index, url) => {
  const normalizeUrl = url.startsWith('http') ? `fetch:${btoa(url)}` : url.replace(/\//gi, ':');

  return `$s_ref:!${normalizeUrl}!/${E_SWAP_IMAGE}:image_$s;index_${index}`;
};

const modelWithVariantImageSwap = (cloudName, publicId, format, variant) => {
  const cloudinary = new Cloudinary({
    cloud: {
      cloudName
    }
  });
  const image = cloudinary.image(`${publicId}.${format}`);
  if (variant?.textures) {
    for (const key of Object.keys(variant.textures)) {
      const texture = variant.textures[key];
      if (texture) {
        const { index, url } = texture;
        if (url) {
          image.addTransformation(swapImageTransformation(index, url));
        }
      }
    }
  }

  return image.toURL().replace(/\?(?:.(?!\?))+$/, '');
};

const getMobileDeviceArSrc = ({ cloudName, publicId, variant, device }) => {
  const format = FORMAT[device];

  return modelWithVariantImageSwap(cloudName, publicId, format, variant);
};

const getAndroidMobileArLink = ({ src, placement }) => {
  // Send to Google Play if ARCore is not available
  const fallbackUrl = 'https://play.google.com/store/apps/details?id=com.google.ar.core';

  let href = `intent://arvr.google.com/scene-viewer/1.0?file=${src}`;
  href += `&enable_vertical_placement=${placement === 'wall' ? 'true' : 'false'}`;
  href += '&mode=ar_only';
  href += '&resizable=true';
  href += '#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;';
  href += `S.browser_fallback_url=${encodeURIComponent(fallbackUrl)};`;
  href += 'end;';

  return href;
};

export const mobileArLinkGenerator = ({ cloudName, publicId, variant, placement }) => {
  if (IS_QUICK_LOOK) {
    const iosSrc = getMobileDeviceArSrc({
      cloudName,
      publicId,
      variant,
      device: 'ios'
    });

    return `${iosSrc}#`;
  } else if (IS_SCREEN_VIEWER) {
    const androidSrc = getMobileDeviceArSrc({
      cloudName,
      publicId,
      variant,
      device: 'android'
    });

    return getAndroidMobileArLink({
      src: androidSrc,
      placement
    });
  }

  return null;
};

// Device detection for AR support
const IS_ANDROID = /android/i.test(navigator.userAgent);

// https://stackoverflow.com/a/9039885/1314762
const isIOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

const IS_SAFARI = /Safari\//.test(navigator.userAgent);
const IS_FIREFOX = /firefox/i.test(navigator.userAgent);
const IS_IOS_CHROME = isIOS() && /CriOS\//.test(navigator.userAgent);
const IS_IOS_SAFARI = isIOS() && IS_SAFARI;

const SUPPORTS_QUICKLOOK = (() => {
  const anchor = document.createElement('a');

  // The try catch is because of a jest bug https://github.com/facebook/jest/issues/9631
  try {
    return anchor.relList?.supports?.('ar');
  } catch (e) {
    return undefined;
  }
})();

const IS_QUICK_LOOK = (IS_IOS_CHROME || IS_IOS_SAFARI) && SUPPORTS_QUICKLOOK;

const IS_SCREEN_VIEWER = IS_ANDROID && !IS_FIREFOX;

export const isDeviceSupportsAr = IS_QUICK_LOOK || IS_SCREEN_VIEWER;
